import React, { useEffect, useState } from "react";
import { useGlobalStates } from "../../utlis/ClubsContext";
import { callApi } from "../../services/ApiServices";
import CommonLoader from "../common/CommonLoader";
import { ErrorMessage, formatTimestamp, validateRequired } from "../../utlis/function";
import { UserRole } from "../../utlis/constant";
import { ImagePath } from "../common/ImagePath";
import ConfirmationModal from "../common/ConfirmationModal";
import CommonPagination from "../common/CommonPagination";
import toast from "react-hot-toast";



const getInitials = (name = "") =>
  name.split(" ").map((n) => n[0]).join("").toUpperCase().slice(0, 2);

const Testimonials = () => {
  const { selectedClub, userRole } = useGlobalStates();
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [testimonials, setTestimonials] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const limit = 10

  const isViewer = userRole === UserRole.Viewer;

  useEffect(() => {
    if (selectedClub?.id)
        fetchTestimonials(currentPage, limit);
  }, [selectedClub]);

  const fetchTestimonials = async (page, limit) => {
    try {
      setLoading(true);
      let ApiUrl = `club/get-testimonial/${selectedClub?.id}?page=${page}&limit=${limit}`; 
      const response = await callApi({
        method: "get",
        url: ApiUrl
      });
      console.log("testimonials", response);
      if (response.status === 200) {
        setTestimonials( response?.testimonials);
        const totalItems = response?.pagination?.total;
        const totalPages = Math.ceil(totalItems/limit)
        setTotalCount(totalPages)
      
      }
    } catch (error) {
      console.log("Error fetching testimonials", error);
    } finally {
      setLoading(false);
    }
  };

 
  const handleSave = async (form) => {
    try {
      setActionLoading(true);
      if (editData) {
        const response = await callApi({
          method: "put",
          url: `club/edit-testimonial/${editData?.id}`,
          data: {
            name: form.name,
            title: form.role,
            description: form.message,
          },
        });
        if (response.status === 200) {
        toast.success( response.message || "Testimonial updated successfully", {id:"updateToast"});
         fetchTestimonials(currentPage, limit)
          setIsModalOpen(false);
          setEditData(null);
        }
      } else {
        const response = await callApi({
          method: "post",
          url: `club/testimonial/${selectedClub?.id}`,
          data: {
            name: form.name,
            title: form.role,
            description: form.message,
          },
        });
        if (response.status === 200 || response.status === 201) {
          toast.success( response.message || "Testimonial added successfully", {id:"addToast"});
        fetchTestimonials(currentPage, limit)         
        setIsModalOpen(false);
        }
      }
    } catch (error) {
      console.log("Error saving testimonial", error);
    } finally {
      setActionLoading(false);
    }
  };


  const handlePageChange = (e)=>{
    setCurrentPage(e)
    fetchTestimonials(e, limit)
  }
  const handleDelete = async () => {
    try {
      setActionLoading(true);
      const response = await callApi({
        method: "delete",
        url: `club/remove-testimonial/${deleteTarget?.id}`,
        data:{}
      });
      if (response.status === 200) {
        toast.success( response.message || "Testimonial deleted successfully", {id:"deleteToast"});
        fetchTestimonials(currentPage, limit)        
        setDeleteTarget(null);
      }
    } catch (error) {
      console.log("Error deleting testimonial", error);
    } finally {
      setActionLoading(false);
    }
  };

  const openEdit = (testimonial) => {
    setEditData(testimonial);
    setIsModalOpen(true);
  };

  const openAdd = () => {
    setEditData(null);
    setIsModalOpen(true);
  };

  return (
    <>
      {loading && <CommonLoader fullScreen />}

      <TestimonialModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setEditData(null);
        }}
        onSave={handleSave}
        editData={editData}
        loading={actionLoading}
      />

      <ConfirmationModal
        isOpen={!!deleteTarget}
        onCancel={() => setDeleteTarget(null)}
        onConfirm={handleDelete}
      />

      {/* Header Card */}
      <div className="bg-white rounded-xl p-6 main-shadow mb-6">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-xl font-semibold text-black tracking-[0] leading-[normal]">
              Testimonials
            </h2>
           
          </div>

          <button
            onClick={openAdd}
            disabled={isViewer}
            className={`flex items-center gap-2 px-4 py-3 rounded-lg text-sm font-medium transition-colors
              ${
                isViewer
                  ? "bg-gray-100 text-gray-400 cursor-not-allowed opacity-50"
                  : "bg-primary hover:bg-hover text-white cursor-pointer"
              }`}
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 1v12M1 7h12"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
              />
            </svg>
            Add New
          </button>
        </div>
      </div>

      {/* Testimonials List */}
      {testimonials.length === 0 && !loading ? (
        <div className="bg-white rounded-xl p-12 main-shadow flex flex-col items-center justify-center text-center">
          <div className="flex justify-center items-center">
            <img
              src={ImagePath?.NoDataFound}
              alt="No Data Found"
              style={{ width: 60, height: 60 }}
            />
          </div>
          <p className="text-medium mt-2">No Data found</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-4">
          {testimonials?.map((item, index) => (
            <div
              key={item?.id || index}
              className="bg-white rounded-xl p-5 main-shadow flex items-start gap-4 group"
            >
              {/* Avatar */}
              <div className="w-11 h-11 rounded-full overflow-hidden flex items-center justify-center bg-primary text-white text-sm font-semibold shrink-0">
             
                  <span>{getInitials(item?.name)}</span>
                
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2">
                  <div>
                    <p className="text-md font-bold text-black leading-tight">
                      {item?.name }
                    </p>
                    {item?.title && (
                      <p className="text-sm text-gray-700 mt-0.5">
                        {item?.title}
                      </p>
                    )}
                 
                  </div>

                  {/* Actions — only visible on hover for non-viewers */}
                  {!isViewer && (
                    <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity shrink-0">
                      <button
                        onClick={() => openEdit(item)}
                        className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 text-gray-400 hover:text-black transition-colors"
                        title="Edit"
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.333 2.00004C11.5081 1.82494 11.716 1.68605 11.9447 1.59129C12.1735 1.49653 12.4187 1.44775 12.6663 1.44775C12.914 1.44775 13.1592 1.49653 13.3879 1.59129C13.6167 1.68605 13.8246 1.82494 13.9997 2.00004C14.1748 2.17513 14.3137 2.383 14.4084 2.61178C14.5032 2.84055 14.552 3.08575 14.552 3.33337C14.552 3.58099 14.5032 3.82619 14.4084 4.05497C14.3137 4.28374 14.1748 4.49161 13.9997 4.66671L4.99967 13.6667L1.33301 14.6667L2.33301 11L11.333 2.00004Z"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                      <button
                        onClick={() => setDeleteTarget(item)}
                        className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-red-50 text-gray-400 hover:text-red-500 transition-colors"
                        title="Delete"
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2 4h12M5.333 4V2.667h5.334V4M6.667 7.333v4M9.333 7.333v4M3.333 4l.667 9.333h8L12.667 4"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                  )}
                </div>

                <p className="text-md text-textcolor mt-2 leading-relaxed">
                  {item?.description}
                </p>

                {item?.createdAt && (
                  <p className="text-sm text-gray-800 mt-2">
                    {formatTimestamp(item?.createdAt)}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
        <CommonPagination
        currentPage={currentPage}
        pageCount={totalCount}
        onPageChange={(e) => handlePageChange(e)}
      /> 
    </>
  );
};

export default Testimonials;


const TestimonialModal = ({ isOpen, onClose, onSave, editData, loading }) => {
  const [form, setForm] = useState({
    name: "",
    role: "",
    message: "",
  });
  const [errors,setErrors] = useState(null)

  useEffect(() => {
    if (editData) {
      setForm({
        name: editData?.name || "",
        role: editData?.title || "",
        message: editData?.description || "",
      });
    } else {
      setForm({ name: "", role: "", message: "",  });
    }
  }, [editData, isOpen]);

  if (!isOpen) return null;

  const isValidForm = (form)=>{
    let newWrrors = {};
    if(!validateRequired(form.name)){
      newWrrors.name = "Name is required"
    }
    if(!validateRequired(form.message)){
      newWrrors.message = "Message is required"
    }else if (form.message.trim().length > 150) {
      newWrrors.message = "Message must be less than 150 characters";
    }
    setErrors(newWrrors);
    return Object.keys(newWrrors).length === 0

  }
  const handleSubmit = () => {
    if (!form.name.trim() || !form.message.trim()) return;
    if(!isValidForm(form)) return;
    onSave(form);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg mx-4 overflow-hidden">
        {/* Modal Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
          <h3 className="text-lg font-semibold text-black">
            {editData ? "Edit Testimonial" : "Add New Testimonial"}
          </h3>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors text-gray-500 hover:text-black"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M12 4L4 12M4 4l8 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        {/* Modal Body */}
        <div className="px-6 py-5 space-y-4">
   

          {/* Name */}
          <div>
            <label className="block text-base font-medium text-black tracking-[0] leading-[normal] mb-2">
              Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={form.name}
              onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
              placeholder="John Doe"
              className="w-full px-4 py-3 bg-white rounded-full text-base font-normal text-black border transition-colors border-gray-200 focus:border-primary focus:outline-none"
            />
            <ErrorMessage message={errors?.name} />
          </div>

          {/* Role */}
          <div>
            <label className="block text-base font-medium text-black tracking-[0] leading-[normal] mb-2">Title</label>
            <input
              type="text"
              value={form.role}
              onChange={(e) => setForm((f) => ({ ...f, role: e.target.value }))}
              placeholder="Club Member"
              className="w-full px-4 py-3 bg-white rounded-full text-base font-normal text-black border transition-colors border-gray-200 focus:border-primary focus:outline-none"
            />
          </div>

         

          {/* Message */}
          <div>
            <label className="block text-base font-medium text-black tracking-[0] leading-[normal] mb-2">
              Message <span className="text-red-500">*</span>
            </label>
            <textarea
              value={form.message}
              onChange={(e) => {setForm((f) => ({ ...f, message: e.target.value }))
             setErrors((prev)=> ({
              ...prev, message: ""
             }))
            }}
              placeholder="Share your experience..."
              rows={4}
              className="w-full px-4 py-3 bg-white rounded-2xl text-base font-normal text-black border transition-colors border-gray-200 focus:border-primary focus:outline-none"
            />
             <ErrorMessage message={errors?.message} />
          </div>
        </div>

        {/* Modal Footer */}

         <div className="flex items-center justify-center gap-2 py-4 px-4 border-t border-gray-200">
            <button
              type="button"
              onClick={onClose}
              className="px-6 py-3 bg-white border flex-1 max-w-[265px] cursor-pointer border-primary text-primary font-medium text-base rounded-full transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Cancel
            </button>
            <button
              type="submit"
              onClick={handleSubmit}
               disabled={loading || !form.name.trim() || !form.message.trim()}
              className="px-6 py-3 bg-primary hover:bg-hover flex-1 max-w-[265px] cursor-pointer disabled:bg-gray-400 disabled:cursor-not-allowed text-white font-medium text-base rounded-full text-center transition-colors justify-center flex items-center gap-2"
            >
              {loading ? (
                <>
                  <svg
                    className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Saving...
                </>
              ) : (
                "Save"
              )}
            </button>
          </div>
      </div>
    </div>
  );
};
